import { ChevronLeft, ChevronRight, ImageOff, Plus } from 'lucide-react'

import { Button, DiagnosticCopy, TextField } from '@krp/ui-kit'

import { QueryState } from './QueryState'
import type { PickerRowVm, PickerVm } from '../port/types'
import { RmkDialog } from './RmkDialog'

/**
 * «☰ Каталог» — подбор в чек поверх РМК (как в старом): товары снимка
 * каталога кассы страницами, поиск — по всему снимку (служба), «В чек» кладёт
 * товар в корзину и оставляет окно открытым для следующего. Недоступный товар
 * объясняет причину словами. Групп и фото у каталога кассы пока нет.
 */
export function CatalogDialog({
  picker,
  locked,
  onSearch,
  onPage,
  onAdd,
  onRetry,
  onClose,
}: {
  picker: PickerVm
  locked: boolean
  onSearch: (value: string) => void
  onPage: (page: number) => void
  onAdd: (row: PickerRowVm) => void
  onRetry: () => void
  onClose: () => void
}) {
  return (
    <RmkDialog title="Каталог кассы" size="lg" onClose={onClose}>
      <div className="rmk-catalog">
        <TextField label="Наименование, артикул или штрихкод" type="search" value={picker.search} onChange={onSearch} />
        <QueryState requestIdHidden query={picker.query} what="Каталог" emptyText="В снимке каталога кассы нет товаров" onRetry={onRetry} />
        {picker.totalText !== '' && <p className="sale-caption">{picker.totalText}</p>}
        {picker.query.status === 'ready' && (
          <ul className="rmk-catalog__list" aria-label="Товары каталога кассы">
            {picker.rows.map((row) => (
              <li key={row.productKey} className="rmk-catalog__row" data-available={row.available}>
                <span className="rmk-thumb" aria-hidden="true">
                  <ImageOff size={16} />
                </span>
                <div className="rmk-catalog__about">
                  <strong>{row.name}</strong>
                  <small>{[row.sku, row.barcode !== null ? `ШК ${row.barcode}` : null, row.unit].filter(Boolean).join(' · ')}</small>
                  {row.reason !== null && (
                    <>
                      <small>Нельзя продать: {row.reason}</small>
                      <DiagnosticCopy text={`${row.name}${row.sku === null ? '' : ` (${row.sku})`}: нельзя продать: ${row.reason}`} label="Скопировать причину" />
                    </>
                  )}
                </div>
                <span className="rmk-catalog__price">{row.priceText}</span>
                <Button
                  icon={<Plus size={15} aria-hidden="true" />}
                  disabled={locked || !row.available}
                  aria-label={`В чек: ${row.name}`}
                  onClick={() => onAdd(row)}
                >
                  В чек
                </Button>
              </li>
            ))}
            {picker.rows.length === 0 && <li className="sale-text">Ничего не найдено</li>}
          </ul>
        )}
        <div className="rmk-catalog__pages">
          <Button variant="ghost" icon={<ChevronLeft size={15} aria-hidden="true" />} disabled={!picker.canPrev} onClick={() => onPage(picker.page - 1)}>
            Назад
          </Button>
          <Button variant="ghost" icon={<ChevronRight size={15} aria-hidden="true" />} disabled={!picker.canNext} onClick={() => onPage(picker.page + 1)}>
            Дальше
          </Button>
          <Button variant="primary" onClick={onClose}>
            Готово
          </Button>
        </div>
      </div>
    </RmkDialog>
  )
}
